/*
 * @Author: ylq
 * @Date: 2022-09-19 15:35:08
 * @Desc: DESC
 * @Last Modified by: ylq
 * @Last Modified time: 2023-06-27 16:37:18
 */
const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');
const DEFAULT_PAGE = () => import('@/layout/page.vue');

const TEST = {
  path: '/test',
  name: 'test',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'test-index' },
  meta: {
    title: '前端组件',
    requiresAuth: true,
    roles: 'test',
    icon: 'icon-dashboard',
    order: 99
  },
  children: [
    {
      path: '',
      name: 'test-index',
      component: () => import('@/views/page-table/page-table.vue'),
      meta: {
        requiresAuth: true,
        roles: 'test',
        title: '数据表格'
      }
    },
    {
      path: 'test-workplace',
      name: 'test-workplace',
      component: () => import('@/views/page-table/dashboard.vue'),
      meta: {
        requiresAuth: true,
        roles: 'test',
        title: '日期选择+图表'
      }
    },
    {
      path: 'page',
      name: 'test-page',
      // component: () => import('@/views/page-table/dashboard.vue'),
      component: DEFAULT_PAGE,
      meta: {
        title: '组件使用',
        roles: 'test',
        requiresAuth: true
      },
      children: [
        {
          path: 'search',
          name: 'test-page-search',
          component: () => import('@/views/page-table/page-search/page-search.vue'),
          meta: {
            requiresAuth: true,
            roles: 'test',
            title: '搜索组件使用'
          }
        }
      ]
    },
    {
      path: 'abc',
      name: 'test-abc',
      component: () => import('@/views/page-table/dashboard.vue'),
      meta: {
        requiresAuth: true,
        roles: 'test',
        title: '路由测试'
      }
    }
  ]
};

export default TEST;
